export enum PaymentMethod {
  ACH = "ach",
  CARD = "card",
}
